import AuthorGenerator from '@/features/author-generator';

function AuthorGeneratorPage() {
  return <AuthorGenerator />;
}

export default AuthorGeneratorPage;

